import styled, { css } from 'styled-components';

export const CoverColumn = styled('div')`
  padding-left: 16px;
  padding-top: 12px;
  width: 84px;
`;

const coverStyle = css`
  max-width: 64px;
  background-color: ${({ theme }) => theme.color.whiteRGBA(0.1)};
  width: 64px;
  height: 40px;
`;

export const Cover = styled('img')`
  ${coverStyle}
  object-fit: cover;
`;

export const CoverFallback = styled('div')`
  ${coverStyle}
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  ${({ theme }) => theme.typography.tiny};
  color: ${({ theme }) => theme.color.whiteRGBA(0.5)};
`;
